import { forwardRef } from 'react';
import './style.css';

const Select = forwardRef(
	({ placeHolder, onChange, name, label, options = [], defaultValue, extraClassName, disabled = false, sortKey }, ref) => {
		return (
			<div className={`Select ${extraClassName ? extraClassName : ''}`}>
				{label && <label>{label}</label>}

				<div className="Select__wrapper">
					<select name={name} onChange={onChange} defaultValue={defaultValue} ref={ref} disabled={disabled}>
						{placeHolder && <option value="">{placeHolder}</option>}
						{options
							?.sort((a, b) => {
								const resolvedSortKey = sortKey || 'description';
								const keyA = a[resolvedSortKey];
								const keyB = b[resolvedSortKey];
								if (typeof keyA === 'number' && typeof keyB === 'number') {
									return keyA - keyB;
								}
								return String(keyA).localeCompare(String(keyB));
							})
							?.map(({ value, description, disabled = false }, idx) => (
								<option value={value} key={idx} disabled={disabled}>
									{description}
								</option>
							))}
					</select>
				</div>
			</div>
		);
	}
);
export default Select;
